<template>
  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-3"
    :class="`${
      isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'
    } ${sidebarType}`"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <a class="m-0 navbar-brand" href="/">
        <span class="ms-2 font-weight-bold text-white" style="font-size: 20px"
          >교육부 만나 관리자 </span
        >
      </a>
    </div>
    <hr class="horizontal light mt-0 mb-2" />
    <sidenav-list />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo-ct.png";
import logoDark from "@/assets/img/logo-ct-dark.png";
import { mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      logoDark,
      Dept: '',
    };
  },
  computed: {
    ...mapState(["isRTL", "sidebarType", "isDarkMode"]),
  },
  mounted() {
  // const user = getUserRole();
  // if (user && user.data) {
  //   console.log("role == ", user.data);
  //   this.Dept = "(" + user.data.classid + "부 )";
  // } else {
  //   console.error("사용자 역할 데이터를 가져오는 데 실패했습니다");
  //   this.Dept = "(알 수 없음)";
  // }
}
};
</script>

<style scoped>
.sidenav {
  z-index: 1200;
  transition: transform 0.3s ease-in-out;
}

@media (max-width: 991.98px) {
  .sidenav {
    transform: translateX(-100%);
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
  }

  .sidenav.g-sidenav-pinned {
    transform: translateX(0);
  }

  .sidenav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1100;
    display: none;
  }

  .g-sidenav-pinned .sidenav-overlay {
    display: block;
  }
}
</style>
